import { ILesson, IActivity } from "@/models/interfaces/lessons";

import { getInitialState, updateState } from "@/utils/helpers/StoreUtil";
import DataProvider from "@/utils/helpers/DataProvider";

import { IVuexState } from "@/models/interfaces/store";
import { AxiosResponse, AxiosError } from "axios";

import { State as RootState } from "@/store";
import { ActionTree, MutationTree, Module } from "vuex";

export interface State {
  lessons: IVuexState<ILesson[]>;
  lessonData: IVuexState<IActivity[]>;
}

export const actions: ActionTree<State, RootState> = {
  async fetchLessons({ commit }, levelId?: string) {
    commit("setLessons");

    const params = levelId ? { levelId } : {};

    return DataProvider.get("lessons", { params })
      .then((response: AxiosResponse) => {
        commit("setLessons", response.data.lessons);
        return response.data.lessons;
      })
      .catch((error: AxiosError) => {
        commit("setLessons", error);
        return error;
      });
  },

  async fetchActivitiesForLesson({ commit }, lessonId: number) {
    commit("setActivities");

    return DataProvider.get(`lessons/${lessonId}`)
      .then((response: AxiosResponse) => {
        commit("setActivities", response.data);
        return response.data;
      })
      .catch((error: AxiosError) => {
        commit("setActivities", error);
        return error;
      });
  },

  async setLessonToClasses(
    _,
    data: { lessonId: string; classesIds: string[] }
  ) {
    return DataProvider.post(
      `lessons/${data.lessonId}/classes`,
      data.classesIds
    );
  },

  async setLessonToSubGroups(
    _,
    data: { lessonId: string; subGroupsIds: string[] }
  ) {
    return DataProvider.post(
      `lessons/${data.lessonId}/subGroups`,
      data.subGroupsIds
    );
  },

  unassignLessonFromClasses(_, classesIds: string[]) {
    return DataProvider.delete("lessons/classes", { data: classesIds });
  },

  unassignLessonFromSubgroups(_, subgroupsIds: string[]) {
    return DataProvider.delete("lessons/subGroups", { data: subgroupsIds });
  }
};

export const mutations: MutationTree<State> = {
  setLessons(state, data?: ILesson[] | AxiosError) {
    state.lessons = updateState(state.lessons, data);
  },

  setActivities(state, data?: IActivity[] | AxiosError) {
    state.lessonData = updateState(state.lessonData, data);
  }
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    lessons: getInitialState(),
    lessonData: getInitialState()
  },
  mutations,
  actions
};

export default store;
